import { HashRouter, Route, Routes } from 'react-router';
import { Front } from './component/layout/Front';
import { Home } from './component/home/Home';
import { AvailableCourses } from './component/courses/AvailableCourses';
import { UpcomingCourses } from './component/courses/UpcomingCourses';
import { Login } from './component/login/Login';
import { CourseList } from './component/admin/CourseList';
import { CourseEventList } from './component/admin/CourseEventList';
import { EmailTool } from './component/admin/EmailTool';
import { AddAdmin } from './component/admin/AddAdmin';
import { RequireAuth } from './context/RequireAuth';
import { ConfirmOptOut } from './component/misc/ConfirmOptOut';
import { ConfirmUnregister } from './component/misc/ConfirmUnregister';
import { Survey } from './component/survey/Survey';
import { SurveySuccess } from './component/survey/SurveySuccess';
import { UserManagement } from './component/admin/UserManagement';

export const App = () => {

  return (
    <HashRouter>
      <Routes>
        <Route path={'/'} element={<Front/>}>
          <Route index element={<Home/>}/>
          <Route path={'/available'} element={<AvailableCourses/>} />
          <Route path={'/upcoming'} element={<UpcomingCourses/>} />
          <Route path={'/login'} element={<Login/>} />
          <Route path={'/opt-out'} element={<ConfirmOptOut/>}/>
          <Route path={'/unregister'} element={<ConfirmUnregister/>} />
          <Route path={'/survey'} element={<Survey/>} />
          <Route path={'/survey/success'} element={<SurveySuccess/>} />
          <Route path={'/courses'} element={
            <RequireAuth>
              <CourseList/>
            </RequireAuth>
          } />
          <Route path={'/events'} element={
            <RequireAuth>
              <CourseEventList/>
            </RequireAuth>
          } />
          <Route path={'/email'} element={
            <RequireAuth>
              <EmailTool/>
            </RequireAuth>
          } />
          <Route path={'/add-admin'} element={
            <RequireAuth>
              <AddAdmin/>
            </RequireAuth>
          } />
          <Route path={'/users'} element={
            <RequireAuth requiredRole="Admin">
              <UserManagement/>
            </RequireAuth>
          } />
        </Route>
      </Routes>
    </HashRouter>
  )
};